export const currencies = [
  { label: 'US Dollar', code: 'USD' },
  { label: 'Canadian Dollar', code: 'CAD' },
  { label: 'Euro', code: 'EUR' },
  { label: 'Hong Kong Dollar', code: 'HKD' },
  { label: 'Australian Dollar', code: 'AUD' },
  { label: 'Singapore Dollar', code: 'SGD' },
];
